import React, { useState, useEffect } from 'react';

const StudentHostelDashboard = ({ onNavigate, userInfo }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API Base URL - adjust this based on your backend configuration
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://app.learninghub.ind.in/api';

  // Fetch dashboard data from backend
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Get user ID from userInfo
        const userId = userInfo?.userId || userInfo?.id;

        if (!userId) {
          throw new Error('User ID not found');
        }

        // Get auth token if available
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');

        const headers = {
          'Content-Type': 'application/json',
        };

        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        // Fetch dashboard data
        const response = await fetch(`${API_BASE_URL}/student/dashboard/${userId}`, {
          method: 'GET',
          headers: headers
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch dashboard data: ${response.statusText}`);
        }

        const data = await response.json();

        if (data.success) {
          setDashboardData(data.dashboard);
        } else {
          throw new Error(data.message || 'Failed to load dashboard data');
        }
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [userInfo, API_BASE_URL]);

  // Static notifications (you can make this dynamic later)
  const notifications = [
    {
      id: 1,
      type: 'payment',
      title: 'Payment Reminder',
      message: dashboardData?.financial?.paymentDueDate
        ? `Your hostel fee payment is due on ${new Date(dashboardData.financial.paymentDueDate).toLocaleDateString()}`
        : 'Payment information not available',
      time: '2h ago',
      icon: '💰',
      unread: true
    },
    {
      id: 2,
      type: 'food',
      title: 'Today\'s Special',
      message: 'Veg Biryani available for dinner. Order now!',
      time: '3h ago',
      icon: '🍛',
      unread: true
    },
    {
      id: 3,
      type: 'request',
      title: 'Request Approved',
      message: 'Your room cleaning request has been approved',
      time: '1d ago',
      icon: '✅',
      unread: false
    }
  ];

  // Prepare stats from dashboard data
  const stats = dashboardData ? [
    {
      icon: '🏠',
      label: 'Room',
      value: dashboardData.stats?.room?.value || dashboardData.room?.roomNumber || 'N/A',
      subtext: dashboardData.stats?.room?.subtext ||
        `Block ${dashboardData.room?.block || 'N/A'}, Floor ${dashboardData.room?.floor || 'N/A'}`
    },
    /*{
      icon: '🏠',
      label: 'Room Rent Per Annum',
      value: `₹${(dashboardData.financial?.roomRent || 0).toLocaleString('en-IN')}`,
      subtext: dashboardData.financial?.roomTypeName
        ? `${dashboardData.financial.roomTypeName} - ${dashboardData.financial.isAC}`
        : 'Annual accommodation charge'
    },
    {
      icon: '🍽️',
      label: 'Food Rent Per Annum',
      value: `₹${(dashboardData.financial?.foodRent || 0).toLocaleString('en-IN')}`,
      subtext: 'Annual food service charge'
    },*/
    {
      icon: '🏨',
      label: 'Hostel',
      value: dashboardData.hostelName || 'N/A',
      subtext: dashboardData.hostelLocation || 'Your accommodation'
    },
  ] : [];


  const quickActions = [
    { icon: '🍽️', label: 'Food Preference', route: 'hostel-student-food-preference' },
    { icon: '📋', label: 'Requisition', route: 'hostel-student-requisition' },
    { icon: '📝', label: 'Requests', route: 'hostel-student-requests' },
    { icon: '📄', label: 'Leave Application', route: 'hostel-student-leaveapply' }
  ];

  // Static meal data (can be fetched from backend later)
  const meals = [
    { meal: 'Breakfast', time: '7:00 - 9:00 AM', items: 'Poha, Tea, Banana', icon: '🥣' },
    { meal: 'Lunch', time: '12:00 - 2:00 PM', items: 'Rice, Dal, Sabzi, Roti', icon: '🍛' },
    { meal: 'Dinner', time: '7:00 - 9:00 PM', items: 'Biryani, Raita, Salad', icon: '🍚' }
  ];
  {/* Rent Breakdown Card */ }
  {
    dashboardData && (
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        {/* Card Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '20px',
          gap: '12px'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px'
          }}>
            💵
          </div>
          <div>
            <div style={{
              fontSize: '20px',
              fontWeight: '700',
              color: '#2b6777'
            }}>
              Rent Breakdown
            </div>
            <div style={{
              fontSize: '14px',
              color: '#6b7280'
            }}>
              Monthly charges for your batch
            </div>
          </div>
        </div>

        {/* Card Body */}
        {dashboardData.financial ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>


            {/* Room Rent */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: '#f9fafb',
              borderRadius: '8px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '24px' }}>🏠</span>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>
                    Room Rent
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>
                    {dashboardData.financial?.roomTypeName
                      ? `${dashboardData.financial.roomTypeName} (${dashboardData.financial.isAC})`
                      : 'Monthly accommodation charge'}
                  </div>
                </div>
              </div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#2b6777' }}>
                ₹{(dashboardData.financial.roomRent || 0).toLocaleString('en-IN')}
              </div>
            </div>

            {/* Food Rent */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px',
              backgroundColor: '#f9fafb',
              borderRadius: '8px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '24px' }}>🍽️</span>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>
                    Food Rent
                  </div>
                  <div style={{ fontSize: '12px', color: '#6b7280' }}>
                    Monthly mess charges
                  </div>
                </div>
              </div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#2b6777' }}>
                ₹{(dashboardData.financial.foodRent || 0).toLocaleString('en-IN')}
              </div>
            </div>

            {/* Laundry Charges (if > 0) */}
            {dashboardData.financial.laundryCharges > 0 && (
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '24px' }}>👕</span>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>
                      Laundry
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      Monthly laundry service
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#2b6777' }}>
                  ₹{(dashboardData.financial.laundryCharges || 0).toLocaleString('en-IN')}
                </div>
              </div>
            )}

            {/* Maintenance Charges (if > 0) */}
            {dashboardData.financial.maintenanceCharges > 0 && (
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px',
                backgroundColor: '#f9fafb',
                borderRadius: '8px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '24px' }}>🔧</span>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151' }}>
                      Maintenance
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      Monthly maintenance fee
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#2b6777' }}>
                  ₹{(dashboardData.financial.maintenanceCharges || 0).toLocaleString('en-IN')}
                </div>
              </div>
            )}

            {/* Total Divider */}
            <div style={{
              height: '2px',
              background: 'linear-gradient(90deg, transparent, #e5e7eb, transparent)',
              margin: '8px 0'
            }}></div>

            {/* Total Monthly Rent */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px',
              background: 'linear-gradient(135deg, #2b6777 0%, #52ab98 100%)',
              borderRadius: '12px',
              color: 'white'
            }}>
              <div>
                <div style={{ fontSize: '16px', fontWeight: '700' }}>
                  Total Monthly Rent
                </div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>
                  All charges included
                </div>
              </div>
              <div style={{ fontSize: '24px', fontWeight: '800' }}>
                ₹{(dashboardData.financial.totalRent || 0).toLocaleString('en-IN')}
              </div>
            </div>

            {/* Security Deposit Info (if > 0) */}
            {dashboardData.financial.securityDeposit > 0 && (
              <div style={{
                padding: '12px',
                backgroundColor: '#fef3c7',
                borderLeft: '4px solid #f59e0b',
                borderRadius: '8px',
                marginTop: '8px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '20px' }}>🔒</span>
                  <div>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#92400e' }}>
                      Security Deposit: ₹{(dashboardData.financial.securityDeposit || 0).toLocaleString('en-IN')}
                    </div>
                    <div style={{ fontSize: '11px', color: '#78350f' }}>
                      One-time refundable deposit
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: '#9ca3af'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>📊</div>
            <div style={{ fontSize: '14px' }}>Rent information not available</div>
          </div>
        )}
      </div>
    )
  }
  // Static entry/exit logs (can be fetched from backend later)
  const entryExitLogs = [
    { type: 'Entry', time: '08:30 AM', date: 'Today', icon: '🟢' },
    { type: 'Exit', time: '06:45 PM', date: 'Yesterday', icon: '🟠' },
    { type: 'Entry', time: '09:15 PM', date: 'Yesterday', icon: '🟢' }
  ];

  const MenuItem = ({ icon, label, active = false, route }) => (
    <div
      className={`menu-item ${active ? 'menu-item-active' : ''}`}
      onClick={() => {
        if (route && onNavigate) {
          onNavigate(route);
        }
        setSidebarOpen(false);
      }}
    >
      <span className="menu-icon">{icon}</span>
      <span className="menu-label">{label}</span>
      <div className="menu-glow"></div>
    </div>
  );

  const handleLogout = () => {
    if (onNavigate) {
      onNavigate('hostel-login');
    }
  };

  // Loading State
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#ffffff',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          border: '6px solid #f3f3f3',
          borderTop: '6px solid #2b6777',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{
          color: '#2b6777',
          fontSize: '18px',
          fontWeight: '600'
        }}>Loading Dashboard...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Error State
  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f4f7fa',
        padding: '2rem'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '3rem',
          textAlign: 'center',
          maxWidth: '500px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.1)'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⚠️</div>
          <h3 style={{ color: '#dc2626', marginBottom: '1rem', fontSize: '1.5rem' }}>
            Error Loading Dashboard
          </h3>
          <p style={{ color: '#666', marginBottom: '2rem' }}>{error}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: '#2b6777',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '0.75rem 1.5rem',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '600'
            }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          -webkit-font-smoothing: antialiased;
          overflow-x: hidden;
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes glow {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }

        .dashboard-container {
          display: flex;
          height: 100vh;
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        /* Sidebar */
        .sidebar {
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          width: 300px;
          background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(242,242,242,0.98) 100%);
          backdrop-filter: blur(30px);
          border-right: 2px solid rgba(82,171,152,0.2);
          transform: translateX(-100%);
          transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 100;
          display: flex;
          flex-direction: column;
          box-shadow: 8px 0 40px rgba(43,103,119,0.15);
        }

        .sidebar.open {
          transform: translateX(0);
        }

        .sidebar-header {
          padding: 36px 28px;
          background: linear-gradient(135deg, rgba(43,103,119,0.05) 0%, rgba(82,171,152,0.05) 100%);
          border-bottom: 2px solid rgba(82,171,152,0.15);
          position: relative;
          overflow: hidden;
        }

        .sidebar-header::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(82,171,152,0.15), transparent);
          animation: shimmer 4s infinite;
        }

        .sidebar-top {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-bottom: 24px;
          position: relative;
          z-index: 1;
        }

        .close-btn {
          background: rgba(43,103,119,0.08);
          border: 1.5px solid rgba(82,171,152,0.25);
          cursor: pointer;
          font-size: 20px;
          color: #2b6777;
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
        }

        .close-btn:hover {
          background: rgba(43,103,119,0.15);
          border-color: #52ab98;
          transform: rotate(90deg);
        }

        .user-info-sidebar {
          display: flex;
          align-items: center;
          gap: 14px;
          position: relative;
          z-index: 1;
        }

        .user-avatar-sidebar {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 22px;
          color: white;
          box-shadow: 0 6px 24px rgba(43,103,119,0.3);
          border: 3px solid rgba(255, 255, 255, 0.5);
        }

        .user-details-sidebar {
          flex: 1;
        }

        .user-name-sidebar {
          font-size: 16px;
          font-weight: 800;
          color: #2b6777;
          margin-bottom: 4px;
        }

        .user-role-sidebar {
          font-size: 13px;
          color: #52ab98;
          font-weight: 600;
        }

        .sidebar-nav {
          flex: 1;
          padding: 28px 20px;
          overflow-y: auto;
        }

        .sidebar-nav::-webkit-scrollbar {
          width: 6px;
        }

        .sidebar-nav::-webkit-scrollbar-track {
          background: rgba(82,171,152,0.08);
        }

        .sidebar-nav::-webkit-scrollbar-thumb {
          background: rgba(82,171,152,0.3);
          border-radius: 3px;
        }

        .menu-item {
          position: relative;
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 18px;
          margin-bottom: 10px;
          cursor: pointer;
          color: #2b6777;
          font-size: 15px;
          font-weight: 600;
          border-radius: 14px;
          transition: all 0.3s;
          overflow: hidden;
        }

        .menu-glow {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(43,103,119,0.08) 0%, rgba(82,171,152,0.08) 100%);
          opacity: 0;
          transition: opacity 0.3s;
        }

        .menu-item:hover {
          color: #52ab98;
          background: rgba(82,171,152,0.1);
          transform: translateX(6px);
          box-shadow: 0 4px 16px rgba(82,171,152,0.15);
        }

        .menu-item:hover .menu-glow {
          opacity: 1;
        }

        .menu-item-active {
          background: linear-gradient(135deg, rgba(43,103,119,0.15) 0%, rgba(82,171,152,0.15) 100%);
          color: #2b6777;
          box-shadow: 0 6px 20px rgba(82,171,152,0.2);
          font-weight: 700;
        }

        .menu-item-active .menu-glow {
          opacity: 1;
          animation: glow 2s ease-in-out infinite;
        }

        .menu-icon {
          font-size: 22px;
          position: relative;
          z-index: 1;
        }

        .menu-label {
          position: relative;
          z-index: 1;
        }

        .logout-section {
          padding: 20px;
          border-top: 2px solid rgba(82,171,152,0.15);
        }

        .logout-btn {
          width: 100%;
          padding: 16px 20px;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          color: white;
          border: none;
          border-radius: 14px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s;
          box-shadow: 0 6px 24px rgba(43,103,119,0.3);
        }

        .logout-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 35px rgba(43,103,119,0.4);
        }

        /* Overlay */
        .overlay {
          position: fixed;
          inset: 0;
          background: rgba(43,103,119,0.4);
          backdrop-filter: blur(6px);
          z-index: 90;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
        }

        .overlay.show {
          opacity: 1;
          visibility: visible;
        }

        .overlay.notifications-overlay {
          z-index: 999;
        }

        /* Main Content */
        .main-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        /* Top Header */
        .top-header {
          background: #ffffff;
          padding: 24px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(82,171,152,0.12);
          position: relative;
          box-shadow: 0 2px 8px rgba(43,103,119,0.06);
        }

        .top-header::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #2b6777 0%, #52ab98 100%);
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 16px;
          flex: 1;
        }

        .menu-toggle {
          background: linear-gradient(135deg, rgba(43,103,119,0.1) 0%, rgba(82,171,152,0.1) 100%);
          border: 2px solid rgba(82,171,152,0.25);
          cursor: pointer;
          font-size: 24px;
          color: #2b6777;
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
          box-shadow: 0 4px 20px rgba(43,103,119,0.15);
          flex-shrink: 0;
        }

        .menu-toggle:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 30px rgba(43,103,119,0.25);
          background: linear-gradient(135deg, rgba(43,103,119,0.15) 0%, rgba(82,171,152,0.15) 100%);
        }

        .header-title-section {
          display: flex;
          flex-direction: column;
          gap: 4px;
          min-width: 0;
          flex: 1;
        }

        .header-greeting {
          font-size: 13px;
          color: #52ab98;
          font-weight: 600;
          display: none;
        }

        .header-name {
          font-size: 18px;
          font-weight: 900;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-shrink: 0;
        }

        .notification-btn {
          position: relative;
          background: rgba(82,171,152,0.1);
          border: 2px solid rgba(82,171,152,0.2);
          cursor: pointer;
          font-size: 20px;
          color: #2b6777;
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s;
        }

        .notification-btn:hover,
        .notification-btn.active {
          background: rgba(82,171,152,0.2);
          border-color: #52ab98;
          box-shadow: 0 6px 24px rgba(82,171,152,0.3);
          transform: scale(1.05);
        }

        .notification-badge {
          position: absolute;
          top: 4px;
          right: 4px;
          min-width: 20px;
          height: 20px;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          border-radius: 10px;
          font-size: 10px;
          font-weight: 800;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 5px;
          color: white;
          border: 2px solid white;
          box-shadow: 0 3px 12px rgba(43,103,119,0.4);
          animation: pulse 2s infinite;
        }

        .user-avatar-header {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 18px;
          color: white;
          cursor: pointer;
          border: 3px solid rgba(82,171,152,0.3);
          transition: all 0.3s;
          box-shadow: 0 6px 24px rgba(43,103,119,0.3);
        }

        .user-avatar-header:hover {
          transform: scale(1.1);
          box-shadow: 0 8px 32px rgba(43,103,119,0.5);
        }

        /* Notifications Panel */
        .notifications-panel {
          position: fixed;
          top: 80px;
          right: 20px;
          width: 380px;
          max-width: calc(100vw - 40px);
          max-height: 600px;
          background: rgba(255,255,255,0.98);
          backdrop-filter: blur(40px);
          border-radius: 20px;
          box-shadow: 0 24px 70px rgba(43,103,119,0.25);
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-20px);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid rgba(82,171,152,0.2);
          overflow: hidden;
        }

        .notifications-panel::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(43,103,119,0.03) 0%, rgba(82,171,152,0.03) 100%);
          opacity: 0.8;
        }

        .notifications-panel.open {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .notifications-header {
          padding: 20px;
          border-bottom: 2px solid rgba(82,171,152,0.15);
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          z-index: 1;
        }

        .notifications-title {
          font-size: 16px;
          font-weight: 900;
          color: #2b6777;
        }

        .mark-all-read {
          background: rgba(82,171,152,0.1);
          border: 1.5px solid rgba(82,171,152,0.25);
          color: #2b6777;
          font-size: 11px;
          font-weight: 700;
          cursor: pointer;
          padding: 8px 14px;
          border-radius: 8px;
          transition: all 0.3s;
        }

        .mark-all-read:hover {
          background: rgba(82,171,152,0.2);
          border-color: #52ab98;
        }

        .notifications-list {
          max-height: 400px;
          overflow-y: auto;
          position: relative;
          z-index: 1;
        }

        .notifications-list::-webkit-scrollbar {
          width: 6px;
        }

        .notifications-list::-webkit-scrollbar-track {
          background: rgba(82,171,152,0.08);
        }

        .notifications-list::-webkit-scrollbar-thumb {
          background: rgba(82,171,152,0.3);
          border-radius: 3px;
        }

        .notification-item {
          padding: 16px 20px;
          border-bottom: 1px solid rgba(82,171,152,0.1);
          cursor: pointer;
          transition: all 0.3s;
          display: flex;
          gap: 14px;
          align-items: flex-start;
          position: relative;
        }

        .notification-item::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 4px;
          background: transparent;
          transition: all 0.3s;
        }

        .notification-item:hover {
          background: rgba(82,171,152,0.08);
        }

        .notification-item:hover::before {
          background: linear-gradient(180deg, #2b6777 0%, #52ab98 100%);
        }

        .notification-item.unread {
          background: rgba(82,171,152,0.05);
        }

        .notification-icon-wrapper {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          flex-shrink: 0;
          background: rgba(82,171,152,0.1);
          border: 1.5px solid rgba(82,171,152,0.2);
        }

        .notification-content {
          flex: 1;
          min-width: 0;
        }

        .notification-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 6px;
        }

        .notification-title {
          font-size: 13px;
          font-weight: 800;
          color: #2b6777;
          flex: 1;
        }

        .notification-unread-dot {
          width: 8px;
          height: 8px;
          background: #52ab98;
          border-radius: 50%;
          box-shadow: 0 0 8px #52ab98;
        }

        .notification-message {
          font-size: 12px;
          color: rgba(43,103,119,0.7);
          margin-bottom: 6px;
          line-height: 1.5;
        }

        .notification-time {
          font-size: 10px;
          color: rgba(43,103,119,0.5);
          font-weight: 700;
        }

        .notifications-footer {
          padding: 14px 20px;
          border-top: 2px solid rgba(82,171,152,0.15);
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .view-all-notifications {
          background: linear-gradient(135deg, rgba(43,103,119,0.1) 0%, rgba(82,171,152,0.1) 100%);
          border: 1.5px solid rgba(82,171,152,0.25);
          color: #2b6777;
          font-size: 12px;
          font-weight: 800;
          cursor: pointer;
          padding: 10px 20px;
          border-radius: 10px;
          transition: all 0.3s;
          width: 100%;
        }

        .view-all-notifications:hover {
          background: linear-gradient(135deg, rgba(43,103,119,0.2) 0%, rgba(82,171,152,0.2) 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(82,171,152,0.2);
        }

        /* Content Wrapper */
        .content-wrapper {
          flex: 1;
          overflow-y: auto;
          padding: 20px 16px;
        }

        .content-wrapper::-webkit-scrollbar {
          width: 8px;
        }

        .content-wrapper::-webkit-scrollbar-track {
          background: rgba(82,171,152,0.08);
        }

        .content-wrapper::-webkit-scrollbar-thumb {
          background: rgba(82,171,152,0.3);
          border-radius: 4px;
        }

        .content-area {
          max-width: 1500px;
          margin: 0 auto;
          animation: slideIn 0.6s ease-out;
        }

        /* Hero Section */
        .hero-section {
          background: linear-gradient(135deg, rgba(43,103,119,0.08) 0%, rgba(82,171,152,0.08) 100%);
          border-radius: 12px;
          padding: 28px 20px;
          margin-bottom: 24px;
          border: 1px solid rgba(82,171,152,0.15);
          box-shadow: 0 2px 8px rgba(43,103,119,0.06);
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #2b6777 0%, #52ab98 100%);
        }

        .hero-content {
          position: relative;
          z-index: 1;
        }

        .hero-title {
          font-size: 24px;
          font-weight: 700;
          color: #2b6777;
          margin-bottom: 8px;
          letter-spacing: -0.5px;
        }

        .hero-subtitle {
          font-size: 13px;
          color: rgba(43,103,119,0.6);
          font-weight: 500;
          line-height: 1.4;
        }

        /* Stats Grid */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-bottom: 24px;
        }

        .stat-card {
          background: #ffffff;
          border-radius: 12px;
          padding: 20px 16px;
          border: 1px solid rgba(43,103,119,0.12);
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(43,103,119,0.06);
        }

        .stat-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(180deg, #2b6777 0%, #52ab98 100%);
          transform: scaleY(0);
          transition: transform 0.3s ease;
        }

        .stat-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(43,103,119,0.12);
          border-color: rgba(82,171,152,0.25);
        }

        .stat-card:hover::before {
          transform: scaleY(1);
        }

        .stat-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 16px;
        }

        .stat-label {
          font-size: 10px;
          color: rgba(43,103,119,0.6);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .stat-icon {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          background: rgba(82,171,152,0.08);
          border: 1px solid rgba(82,171,152,0.15);
        }

        .stat-value {
          font-size: 26px;
          font-weight: 700;
          color: #2b6777;
          margin-bottom: 6px;
          letter-spacing: -0.5px;
          line-height: 1;
        }

        .stat-subtext {
          font-size: 11px;
          color: rgba(43,103,119,0.5);
          font-weight: 500;
        }
        
        /* Quick Actions */
        .quick-actions-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-bottom: 24px;
        }

        .action-card {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(30px);
          border-radius: 16px;
          padding: 24px 16px;
          border: 2px solid rgba(82,171,152,0.2);
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          text-align: center;
          position: relative;
          overflow: hidden;
          box-shadow: 0 4px 16px rgba(43,103,119,0.08);
        }

        .action-card::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(43,103,119,0.08) 0%, rgba(82,171,152,0.08) 100%);
          opacity: 0;
          transition: opacity 0.4s;
        }

        .action-card:hover {
          transform: translateY(-6px) scale(1.03);
          box-shadow: 0 12px 32px rgba(43,103,119,0.18);
          border-color: rgba(82,171,152,0.4);
        }

        .action-card:hover::before {
          opacity: 1;
        }

        .action-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          margin: 0 auto 16px;
          background: linear-gradient(135deg, rgba(43,103,119,0.1) 0%, rgba(82,171,152,0.1) 100%);
          border: 2px solid rgba(82,171,152,0.25);
          transition: all 0.4s;
          position: relative;
          z-index: 1;
        }

        .action-card:hover .action-icon {
          transform: scale(1.1) rotate(5deg);
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          border-color: transparent;
        }

        .action-label {
          font-size: 13px;
          font-weight: 800;
          color: #2b6777;
          position: relative;
          z-index: 1;
        }

        /* Section */
        .section {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(30px);
          border-radius: 16px;
          padding: 24px 20px;
          margin-bottom: 24px;
          border: 2px solid rgba(82,171,152,0.2);
          box-shadow: 0 4px 16px rgba(43,103,119,0.08);
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
        }

        .section-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
          border: 2px solid rgba(82,171,152,0.3);
          color: white;
          box-shadow: 0 4px 16px rgba(43,103,119,0.2);
          flex-shrink: 0;
        }

        .section-title {
          font-size: 18px;
          font-weight: 900;
          color: #2b6777;
        }

        /* Entry Exit Grid */
        .entry-exit-grid {
          display: grid;
          gap: 12px;
        }

        .entry-exit-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px 12px;
          background: rgba(82,171,152,0.08);
          border-radius: 12px;
          border: 1.5px solid rgba(82,171,152,0.2);
          transition: all 0.3s;
        }

        .entry-exit-item:hover {
          background: rgba(82,171,152,0.15);
          border-color: rgba(82,171,152,0.3);
          transform: translateX(4px);
          box-shadow: 0 4px 16px rgba(43,103,119,0.12);
        }

        .entry-exit-icon {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: rgba(255,255,255,0.8);
          border: 1.5px solid rgba(82,171,152,0.25);
          flex-shrink: 0;
        }

        .entry-exit-info {
          flex: 1;
          min-width: 0;
        }

        .entry-exit-type {
          font-size: 14px;
          font-weight: 800;
          color: #2b6777;
          margin-bottom: 4px;
        }

        .entry-exit-time {
          font-size: 12px;
          color: rgba(43,103,119,0.7);
          margin-bottom: 2px;
          font-weight: 600;
        }

        .entry-exit-date {
          font-size: 11px;
          color: rgba(43,103,119,0.5);
          font-weight: 600;
        }

        /* Meals Grid */
        .meals-grid {
          display: grid;
          gap: 12px;
        }

        .meal-card {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 14px;
          background: rgba(82,171,152,0.08);
          border-radius: 14px;
          border: 1.5px solid rgba(82,171,152,0.2);
          transition: all 0.3s;
        }

        .meal-card:hover {
          background: rgba(82,171,152,0.15);
          transform: translateX(4px);
          box-shadow: 0 6px 20px rgba(43,103,119,0.12);
        }

        .meal-icon-wrapper {
          width: 52px;
          height: 52px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          background: rgba(255,255,255,0.9);
          border: 2px solid rgba(82,171,152,0.25);
          flex-shrink: 0;
        }

        .meal-info {
          flex: 1;
          min-width: 0;
        }

        .meal-name {
          font-size: 16px;
          font-weight: 900;
          color: #2b6777;
          margin-bottom: 6px;
        }

        .meal-time {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
          color: #52ab98;
        }

        .meal-items {
          font-size: 11px;
          color: rgba(43,103,119,0.6);
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        /* Responsive - Tablet */
        @media (min-width: 768px) {
          .top-header {
            padding: 32px 24px;
          }

          .header-name {
            font-size: 22px;
          }

          .header-greeting {
            display: block;
            font-size: 14px;
          }

          .header-title-section {
            flex-direction: row;
            align-items: center;
            gap: 12px;
          }

          .content-wrapper {
            padding: 32px 24px;
          }

          .hero-section {
            padding: 48px 28px;
          }

          .hero-title {
            font-size: 32px;
          }

          .hero-subtitle {
            font-size: 15px;
          }

          .stats-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 16px;
          }

          .stat-card {
            padding: 24px 20px;
          }

          .quick-actions-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
          }

          .action-card {
            padding: 32px 20px;
          }

          .action-icon {
            width: 64px;
            height: 64px;
            font-size: 32px;
            margin-bottom: 20px;
          }

          .action-label {
            font-size: 14px;
          }

          .section {
            padding: 32px 28px;
          }

          .section-header {
            gap: 16px;
            margin-bottom: 28px;
          }

          .section-icon {
            width: 56px;
            height: 56px;
            font-size: 28px;
          }

          .section-title {
            font-size: 22px;
          }

          .entry-exit-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }

          .entry-exit-item {
            padding: 20px 16px;
            gap: 16px;
          }

          .entry-exit-icon {
            width: 52px;
            height: 52px;
            font-size: 26px;
          }

          .entry-exit-type {
            font-size: 16px;
          }

          .meals-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .meal-card {
            padding: 20px 18px;
            gap: 18px;
          }

          .meal-icon-wrapper {
            width: 64px;
            height: 64px;
            font-size: 32px;
          }

          .meal-name {
            font-size: 18px;
          }
        }

        /* Responsive - Desktop */
        @media (min-width: 1024px) {
          .sidebar {
            position: static;
            transform: translateX(0);
          }

          .close-btn {
            display: none;
          }

          .overlay {
            display: none !important;
          }

          .menu-toggle {
            display: none;
          }

          .top-header {
            padding: 52px 32px;
          }

          .header-name {
            font-size: 28px;
          }

          .header-greeting {
            font-size: 18px;
          }

          .content-wrapper {
            padding: 56px 48px;
          }

          .hero-section {
            padding: 90px 36px;
          }

          .hero-title {
            font-size: 36px;
          }

          .hero-subtitle {
            font-size: 16px;
          }

          .stats-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
          }

          .stat-card {
            padding: 28px;
          }

          .stat-label {
            font-size: 12px;
          }

          .stat-icon {
            width: 48px;
            height: 48px;
            font-size: 24px;
          }

          .stat-value {
            font-size: 32px;
          }

          .stat-subtext {
            font-size: 13px;
          }

          .quick-actions-grid {
            gap: 24px;
          }

          .action-card {
            padding: 40px 28px;
            border-radius: 28px;
          }

          .action-icon {
            width: 80px;
            height: 80px;
            font-size: 40px;
            border-radius: 24px;
            margin-bottom: 24px;
          }

          .action-label {
            font-size: 16px;
          }

          .section {
            padding: 40px;
            border-radius: 28px;
          }

          .section-header {
            gap: 20px;
            margin-bottom: 32px;
          }

          .section-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            font-size: 32px;
          }

          .section-title {
            font-size: 28px;
          }

          .entry-exit-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }

          .entry-exit-item {
            padding: 24px;
            gap: 20px;
            border-radius: 20px;
          }

          .entry-exit-icon {
            width: 56px;
            height: 56px;
            border-radius: 14px;
            font-size: 28px;
          }

          .entry-exit-type {
            font-size: 16px;
            margin-bottom: 6px;
          }

          .entry-exit-time {
            font-size: 14px;
            margin-bottom: 4px;
          }

          .entry-exit-date {
            font-size: 13px;
          }

          .meals-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 24px;
          }

          .meal-card {
            padding: 28px;
            gap: 24px;
            border-radius: 24px;
          }

          .meal-icon-wrapper {
            width: 72px;
            height: 72px;
            border-radius: 18px;
            font-size: 36px;
          }

          .meal-name {
            font-size: 20px;
            margin-bottom: 8px;
          }

          .meal-time {
            font-size: 14px;
            margin-bottom: 6px;
          }

          .meal-items {
            font-size: 13px;
          }
        }

        /* Small mobile adjustments */
        @media (max-width: 380px) {
          .header-name {
            font-size: 16px;
          }

          .hero-title {
            font-size: 20px;
          }

          .stat-value {
            font-size: 22px;
          }

          .action-icon {
            width: 48px;
            height: 48px;
            font-size: 24px;
          }

          .action-label {
            font-size: 12px;
          }
        }
      `}</style>

      <div className="dashboard-container">
        {/* Sidebar */}
        <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="sidebar-header">
            <div className="sidebar-top">
              <button onClick={() => setSidebarOpen(false)} className="close-btn">
                ✕
              </button>
            </div>
            <div className="user-info-sidebar">
              <div className="user-avatar-sidebar">
                {dashboardData?.name ? dashboardData.name.charAt(0).toUpperCase() :
                  userInfo?.name ? userInfo.name.charAt(0).toUpperCase() : 'S'}
              </div>
              <div className="user-details-sidebar">
                <div className="user-name-sidebar">
                  {dashboardData?.name || userInfo?.name || 'Student Name'}
                </div>
                <div className="user-role-sidebar">Student Portal</div>
              </div>
            </div>
          </div>

          <nav className="sidebar-nav">
            <MenuItem icon="🏠" label="Dashboard" active={true} route="hostel-student-dashboard" />
            <MenuItem icon="🚪" label="Entry/Exit Log" route="hostel-student-entry-exit-log" />
            <MenuItem icon="🛏" label="Room Details" route="hostel-student-room-details" />
            <MenuItem icon="🍽️" label="Food Preference" route="hostel-student-food-preference" />
            <MenuItem icon="🧺" label="Laundry Service" route="hostel-student-laundry" />
            <MenuItem icon="💳" label="Grievance" route="hostel-student-payments" />
            <MenuItem icon="📝" label="Requests" route="hostel-student-requests" />
            <MenuItem icon="📋" label="Requisition" route="hostel-student-requisition" />
          </nav>

          <div className="logout-section">
            <button onClick={handleLogout} className="logout-btn">
              🚪 Logout
            </button>
          </div>
        </div>

        {/* Overlays */}
        <div
          className={`overlay ${sidebarOpen ? 'show' : ''}`}
          onClick={() => setSidebarOpen(false)}
        />
        <div
          className={`overlay notifications-overlay ${notificationsOpen ? 'show' : ''}`}
          onClick={() => setNotificationsOpen(false)}
        />

        {/* Main Content */}
        <div className="main-content">
          {/* Top Header */}
          <div className="top-header">
            <div className="header-left">
              <button
                className="menu-toggle"
                onClick={() => setSidebarOpen(true)}
              >
                ☰
              </button>
              <div className="header-title-section">
                <div className="header-greeting">Welcome back,</div>
                <div className="header-name">
                  {dashboardData?.name || userInfo?.name || 'Student'}
                </div>
              </div>
            </div>
            <div className="header-right">
              <div className="user-avatar-header">
                {dashboardData?.name ? dashboardData.name.charAt(0).toUpperCase() :
                  userInfo?.name ? userInfo.name.charAt(0).toUpperCase() : 'S'}
              </div>
            </div>
          </div>

          {/* Notifications Panel */}
          <div className={`notifications-panel ${notificationsOpen ? 'open' : ''}`}>
            <div className="notifications-header">
              <div className="notifications-title">Notifications</div>
              <button className="mark-all-read">Mark all read</button>
            </div>
            <div className="notifications-list">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${notification.unread ? 'unread' : ''}`}
                >
                  <div className="notification-icon-wrapper">
                    {notification.icon}
                  </div>
                  <div className="notification-content">
                    <div className="notification-header">
                      <div className="notification-title">{notification.title}</div>
                      {notification.unread && <div className="notification-unread-dot"></div>}
                    </div>
                    <div className="notification-message">{notification.message}</div>
                    <div className="notification-time">{notification.time}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="notifications-footer">
              <button className="view-all-notifications">View All</button>
            </div>
          </div>

          {/* Content */}
          <div className="content-wrapper">
            <div className="content-area">
              {/* Hero Section */}
              <div className="hero-section">
                <div className="hero-content">
                  <h1 className="hero-title">
                    Hello, {dashboardData?.name || userInfo?.name || 'Student'}! 👋
                  </h1>
                  <p className="hero-subtitle">
                    Welcome to your modern hostel management dashboard
                    {dashboardData?.hostelName && ` - ${dashboardData.hostelName}`}
                  </p>
                </div>
              </div>

              {/* Stats Grid */}
              <div className="stats-grid">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-card">
                    <div className="stat-header">
                      <div className="stat-label">{stat.label}</div>
                      <div className="stat-icon">{stat.icon}</div>
                    </div>
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-subtext">{stat.subtext}</div>
                  </div>
                ))}
              </div>

              {/* Quick Actions */}
              <div className="quick-actions-grid">
                {quickActions.map((action, index) => (
                  <div
                    key={index}
                    className="action-card"
                    onClick={() => action.route && onNavigate && onNavigate(action.route)}
                  >
                    <div className="action-icon">{action.icon}</div>
                    <div className="action-label">{action.label}</div>
                  </div>
                ))}
              </div>

              {/* Entry/Exit Section */}
              <div className="section">
                <div className="section-header">
                  <div className="section-icon">🚹</div>
                  <div className="section-title">Entry & Exit Logs</div>
                </div>
                <div className="entry-exit-grid">
                  {entryExitLogs.map((log, index) => (
                    <div key={index} className="entry-exit-item">
                      <div className="entry-exit-icon">{log.icon}</div>
                      <div className="entry-exit-info">
                        <div className="entry-exit-type">{log.type}</div>
                        <div className="entry-exit-time">{log.time}</div>
                        <div className="entry-exit-date">{log.date}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Meals Section */}
              <div className="section">
                <div className="section-header">
                  <div className="section-icon">🍽️</div>
                  <div className="section-title">Today's Menu</div>
                </div>
                <div className="meals-grid">
                  {meals.map((meal, index) => (
                    <div key={index} className="meal-card">
                      <div className="meal-icon-wrapper">{meal.icon}</div>
                      <div className="meal-info">
                        <div className="meal-name">{meal.meal}</div>
                        <div className="meal-time">{meal.time}</div>
                        <div className="meal-items">{meal.items}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentHostelDashboard;